/** Religion is recorded independently from the chosen obituary term. */
//* 국가유공자는 종교가 아니지만 부고장 테마 어셋이 테마당 1벌이라 택1이어야 함 → 같은 선택지에 둔다(별도 체크 금지)
export const deceasedReligions = [
  'none',
  'buddhist',
  'christian',
  'catholic',
  'nationalMerit',
] as const;
export type DeceasedReligion = typeof deceasedReligions[number];

//* Select 맨 위 "선택 안 함" — 한 번 고른 종교를 비워 옛 기본 헤더(訃告)로 되돌리는 유일한 경로(2026-11-02 사용자 지적).
//* value ''는 공용 Select의 placeholder 값이라 저장 시 religion 생략(undefined)으로 떨어진다
export const RELIGION_UNSET_OPTION = {
  value: '',
  label: '선택 안 함 (기본 부고장)',
} as const;

export const religionLabels: Record<DeceasedReligion, string> = {
  none: '무교(일반)',
  buddhist: '불교',
  christian: '기독교',
  catholic: '천주교',
  nationalMerit: '국가유공자',
};
//* 불교는 실제론 '열반'보다 '별세'를 많이 써서 추천하지 않는다(2026-11-02 사용자) — 필요하면 용어 Select에서 직접 선택
export const recommendedBugoTerm = (religion?: DeceasedReligion) => {
  if (religion === 'christian') return '소천';
  if (religion === 'catholic') return '선종';
  return '별세';
};

/** Keep a separately chosen term when changing religion. Never infer religion from a term. */
export const bugoTermAfterReligionChange = (
  current: string | undefined,
  previous: DeceasedReligion | undefined,
  next: DeceasedReligion | undefined,
) =>
  !current || current === recommendedBugoTerm(previous)
    ? recommendedBugoTerm(next)
    : current;

/** 고인정보 폼 종교 Select 옵션: 선택 안 함 + 종교(국가유공자 포함) */
export const religionSelectOptions = [
  RELIGION_UNSET_OPTION,
  ...deceasedReligions.map((value) => ({ value, label: religionLabels[value] })),
];
